<template>
	<button v-if="visible" id="mockResetButton" type="button" class="mock-reset-button" title="Mock mode: reset the mock data and start over as a first-time visitor" @click="resetMock">M</button>
</template>

<script setup>
/**
 * Only in mock mode (the caller checks config.mockBackend): a small red "M", sticky at the top right.
 * A click makes this browser a first-time visitor of Polly again - the mock data is wiped, and so is everything this
 * origin remembers: the polly passkey session, the draft, the name. Then it starts over on the form for a new
 * polly - Polly's start page, never LIQUIDO's. The mock server
 * then does not know the passkey any more, so a polly the visitor creates registers a new one.
 * A real authenticator keeps its credential (a web page cannot delete it), but nothing refers to it.
 */
import config from "config"

/** Not in a Cypress run: the M would sit on top of the header buttons there, and no spec has a use for it */
const visible = !window.Cypress

function resetMock() {
	// The mocked database lives in the dev server process, not in this tab - see mock-backend/
	fetch("/mock/reset", { method: "POST" })
		.catch(err => console.warn("Cannot reset mock state", err))
		.finally(() => {
			try {
				localStorage.clear()
				sessionStorage.clear()
			} catch (e) { /* storage disabled: nothing to forget */ }
			window.location.assign((config.BASE_URL || "/") + "polly")
		})
}
</script>

<style scoped>
.mock-reset-button {
	position: fixed;
	top: max(2px, env(safe-area-inset-top));
	right: 2px;
	z-index: 10000;   /* above Athena's fixed header */
	display: flex;
	align-items: center;
	justify-content: center;
	width: 22px;
	height: 22px;
	padding: 0;
	border: 0;
	border-radius: 50%;
	background: #d62828;
	color: #fff;
	font: 700 0.85rem/1 system-ui, sans-serif;
	opacity: 0.85;
	cursor: pointer;
}
.mock-reset-button:hover,
.mock-reset-button:focus-visible {
	opacity: 1;
}
</style>
